/* eslint-disable array-callback-return */ // disabled this because this linting conflicts with the functionality.
/* eslint-disable react/no-array-index-key */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CopyToClipboard from 'react-copy-to-clipboard';
import {
  Dropdown,
  Divider,
  Icon,
  Button,
  Modal,
  Loader,
  Form,
  Tab,
  TextArea,
  Grid,
  Popup,
  Checkbox
} from 'semantic-ui-react';
import { toast, ToastContainer } from 'react-toastify';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import _ from 'lodash';
import shortid from 'short-id';
import * as AppActions from '../../actions';
import { getLastWeek, getLastMonth } from '../../utils/dates';
import {
  generateIframeForAccount,
  insertIframe,
  getIframes,
  removeIframe,
  updateIframe,
  getLookerAccounts,
  refreshLookerAccounts,
  getLookerFilters,
  refreshLookerFilters
} from '../../services/InsightsPreviewManager';
import InsightsList from './InsightsList';
import {
  getDashboards,
  getDashboardTags
} from '../../services/DashboardService';
import { getTagsForCategories } from '../../services/TagService';
import './InsightsPreview.css';

class InsightsPreview extends Component {
  state = {
    token: this.props.getFbToken(),
    accountOptions: null,
    dashboardOptions: [],
    oemsOptions: [],
    marketOptions: [],
    specialCampaignOptions: [],
    dashboards: null,
    dashboardTags: null,
    datesOptions: [],
    selectedMarkets: [],
    selectedSpecialCampaigns: [],
    selectedAccount: '',
    selectedDashboards: '',
    selectedDate: '',
    dateFrom: '',
    dateTo: '',
    iframe: '',
    showForm: false,
    copied: false,
    urlString: '',
    selectedWeeks: 365,
    iframes: [],
    selectedDashboardForPreview: '',
    commaSeparatedInput: '',
    tagsByCategoryOptions: [],
    fundingTagOptions: [],
    chosenTagsByCategory: [],
    chosenFundingTags: [],
    funding: '',
    matchedDashboards: [],
    market: '',
    oem: '',
    commaListVisible: false,
    datePickerVisible: false,
    selectedDashboardsArray: [],
    shareLinkOpen: false,
    shareLinkPopupText: '',
    restrictByOem: false,
    filters: null,
    hasPassword: false,
    currentPassword: ''
  };

  errorMessageRef = null;

  componentDidMount() {
    this.props.setSectionTitle('Insights Preview');
    this.props.saveGTMEvent('Insights Preview', 'Insights Preview');
    this.getDashboards();
    this.getIframes();
    this.getAdAccounts();
    this.fillWeeks();
    this.fillFilters();
    this.fillDates();

    const tagCategories = ['dashboard_type', 'funding'];

    this.setTagOptionValuesByCategory(tagCategories);
  }

  getDashboards = async () => {
    const dashboards = await getDashboards();
    const tags = await getDashboardTags();
    const dashboardOptions = _.map(dashboards.dashboards, (op, index) => ({
      key: index,
      value: op.dashboard_id,
      text: op.name,
      id: op.id,
      tags: tags.dashboards.filter((tag) => tag.dashboard_id === op.id)
    }));

    this.setState({
      dashboards: dashboards.dashboards,
      dashboardOptions,
      matchedDashboards: dashboardOptions
    });
  };

  resetDashboardsTags = async () => {
    this.getDashboards();
    this.getAdAccounts();
    this.fillFilters(null, true);
    this.setState({
      chosenTagsByCategory: [],
      chosenFundingTags: [],
      funding: '',
      market: '',
      oem: '',
      selectedMarkets: [],
      selectedAccount: '',
      selectedDashboardsArray: [],
      selectedDashboards: '',
      selectedDashboardForPreview: '',
      selectedSpecialCampaigns: []
    });
  };

  fillFilters = async (accounts, refreshMode) => {
    const oemsOptions = [];
    const marketOptions = [];
    const specialCampaignOptions = [];
    let filterOptions = refreshMode
      ? await refreshLookerFilters()
      : await getLookerFilters();

    if (accounts) {
      const { filters } = this.state;
      filterOptions = filters.filter(
        (filter) => accounts.indexOf(filter.account || filter) !== -1
      );
    }

    filterOptions.forEach((op, index) => {
      if (!oemsOptions.find((oem) => oem && oem.text === op.oem)) {
        oemsOptions.push({
          key: index,
          value: op.oem,
          text: op.oem
        });
      }

      if (
        !marketOptions.find((market) => market && market.text === op.market)
      ) {
        if (op.market !== null && op.market.trim() !== '') {
          marketOptions.push({
            key: index + 1,
            value: op.market,
            text: op.market
          });
        }
      }
      op.special_campaigns.forEach((specialCampaign) => {
        if (
          !specialCampaignOptions.find(
            (scOp) => scOp && scOp.text === specialCampaign
          )
        ) {
          if (specialCampaign !== null && specialCampaign.trim() !== '') {
            specialCampaignOptions.push({
              key: `${specialCampaign}-${index + 1}`,
              value: specialCampaign,
              text: specialCampaign
            });
          }
        }
      });
    });

    const managedServicesOption = {
      key: specialCampaignOptions.length + 1,
      value: 'Managed Services',
      text: 'Managed Services'
    };

    specialCampaignOptions.push(managedServicesOption);

    this.setState({
      ...this.state,
      oemsOptions: _.sortBy(oemsOptions, ['text']),
      marketOptions: _.sortBy(marketOptions, ['text']),
      specialCampaignOptions: _.sortBy(specialCampaignOptions, ['text']),
      filters: filterOptions
    });
  };

  fillDates = async () => {
    const dates = [
      'Today',
      'Yesterday',
      '7 days',
      '14 days',
      '30 days',
      'This Week',
      'Last Week',
      'This Month',
      'Last Month'
    ];
    const datesOptions = _.map(dates, (op, index) => ({
      key: index,
      value: op,
      text: op
    }));

    this.setState({ datesOptions });
  };

  getIframes = async () => {
    const iframes = await getIframes();
    this.setState({ iframes: iframes.iframes });
  };

  getAdAccounts = async () => {
    // this returns an array of of objects containing .account, .oem, and more
    const nonSocialAccounts = await getLookerAccounts();

    try {
      const accountOptions = _.sortBy(
        _.map(nonSocialAccounts, (op, index) => ({
          key: index,
          value: op.account || op,
          text: op.account || op
        })),
        'text'
      );

      this.setState({
        accountOptions
      });
    } catch (error) {
      console.log(error);
    }
  };

  setTagOptionValuesByCategory = async (categoryStrings) => {
    try {
      const dataFromServiceCall = await getTagsForCategories(categoryStrings);
      const { results } = dataFromServiceCall;

      const tagsByCategory = results;
      categoryStrings.forEach((categoryString) => {
        const inFunctionTagsByCategory = [];

        const currentTagGroupFromState = tagsByCategory.find(
          (tagGroup) => tagGroup.category === categoryString
        );

        if (categoryString !== 'funding') {
          inFunctionTagsByCategory.push({
            key: 0,
            value: '',
            text: ''
          });
        }

        try {
          const tags = currentTagGroupFromState.tags;
          for (let j = 0; j < tags.length; j += 1) {
            const tagOption = {
              key: categoryString === 'funding' ? j : j + 1,
              text: tags[j].value,
              value: tags[j].id
            };
            inFunctionTagsByCategory.push(tagOption);
          }

          const tagGroup = {
            category: categoryString,
            tags: inFunctionTagsByCategory
          };

          this.setState((prevState) => ({
            tagsByCategoryOptions: [
              ...prevState.tagsByCategoryOptions,
              tagGroup
            ]
          }));
        } catch (error) {
          toast.warn(
            `An error occured when getting tags for ${categoryString}`,
            {
              position: 'bottom-center',
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true
            }
          );
          console.log('error in setTagOptionValuesByCategory() ', error);
        }
      });
    } catch (error) {
      toast.warn('An error occured when getting tags', {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
      });
      console.log('error in setTagOptionValuesByCategory()', error);
    }
  };

  onOemSelect = (event, data) => {
    const { filters } = this.state;
    const oem = _.find(data.options, (option) => {
      return option.value === data.value;
    });

    if (oem.value !== '') {
      const marketOptions = [];
      const accountOptions = [];
      const specialCampaignOptions = [];

      const {
        selectedAccount,
        selectedMarkets,
        selectedSpecialCampaigns
      } = this.state;

      const filterOptions = filters.filter((filter) => filter.oem === oem.text);

      filterOptions.forEach((op, index) => {
        const accountOption = op.account || op;
        if (
          !accountOptions.find(
            (account) => oem && account.text === accountOption
          )
        ) {
          if (selectedMarkets.length <= 0) {
            accountOptions.push({
              key: index,
              value: accountOption,
              text: accountOption
            });
          } else {
            selectedMarkets.forEach((market) => {
              if (op.market === market) {
                accountOptions.push({
                  key: index,
                  value: accountOption,
                  text: accountOption
                });
              }
            });
          }
        }

        if (
          !marketOptions.find((market) => market && market.text === op.market)
        ) {
          if (op.market) {
            marketOptions.push({
              key: index,
              value: op.market,
              text: op.market
            });
          }
        }

        op.special_campaigns.forEach((specialCampaign) => {
          if (
            !specialCampaignOptions.find(
              (scOp) => scOp && scOp.text === specialCampaign
            )
          ) {
            if (specialCampaign !== null && specialCampaign.trim() !== '') {
              specialCampaignOptions.push({
                key: index + 1,
                value: specialCampaign,
                text: specialCampaign
              });
            }
          }
        });
      });

      const managedServicesOption = {
        key: specialCampaignOptions.length + 1,
        value: 'Managed Services',
        text: 'Managed Services'
      };

      specialCampaignOptions.push(managedServicesOption);

      const newMarketData = this.findMatchingSelectedMarkets(
        selectedMarkets,
        marketOptions
      );

      const newSelectedAccounts =
        selectedAccount !== ''
          ? this.findMatchingSelectedAccounts(selectedAccount, accountOptions)
          : selectedAccount;

      const newSelectedSpecialCampaigns =
        selectedSpecialCampaigns.length > 0
          ? this.findMatchingSpecialCampaigns(
              selectedSpecialCampaigns,
              specialCampaignOptions
            )
          : selectedSpecialCampaigns;

      this.setState({
        oem: oem.value,
        accountOptions,
        marketOptions,
        market: newMarketData.market,
        selectedMarkets: newMarketData.selectedMarkets,
        specialCampaignOptions,
        selectedAccount: newSelectedAccounts,
        selectedSpecialCampaigns: newSelectedSpecialCampaigns
      });
    }
  };

  onMarketSelect = (event, { value, options }) => {
    let markets = '';
    const selectedMarkets = [];
    const {
      oem,
      selectedAccount,
      selectedSpecialCampaigns,
      filters
    } = this.state;

    value.map((val) => {
      const market = _.find(options, (option) => {
        return option.value === val;
      });
      if (market === undefined || market.text === undefined) {
        markets += '';
      } else {
        markets += markets === '' ? market.text : `,${market.text}`;
        selectedMarkets.push(market.value);
      }
    });

    const oemsOptions = []; // disabled for now (see below)
    const accountOptions = [];
    const specialCampaignOptions = [];
    const filterOptions =
      markets !== ''
        ? filters.filter((filter) =>
            selectedMarkets.find((item) => item === filter.market)
          )
        : filters;

    filterOptions.forEach((op, index) => {
      const accountOption = op.account || op;
      if (
        !accountOptions.find(
          (account) => account && account.text === accountOption
        )
      ) {
        if (oem === '' || (op.oem === oem && oem !== '')) {
          accountOptions.push({
            key: index,
            value: accountOption,
            text: accountOption
          });
        }
      }

      // to do: reset oemOptions if markets is empty
      if (!oemsOptions.find((oemArg) => oemArg && oemArg.text === op.oem)) {
        oemsOptions.push({
          key: index,
          value: op.oem,
          text: op.oem
        });
      }

      op.special_campaigns.forEach((specialCampaign) => {
        if (
          !specialCampaignOptions.find(
            (scOp) => scOp && scOp.text === specialCampaign
          )
        ) {
          if (specialCampaign !== null && specialCampaign.trim() !== '') {
            specialCampaignOptions.push({
              key: index + 1,
              value: specialCampaign,
              text: specialCampaign
            });
          }
        }
      });
    });

    const managedServicesOption = {
      key: specialCampaignOptions.length + 1,
      value: 'Managed Services',
      text: 'Managed Services'
    };

    specialCampaignOptions.push(managedServicesOption);

    const newSelectedOem =
      oem !== '' ? this.findMatchingOem(oem, oemsOptions) : '';

    const newSelectedSpecialCampaigns =
      selectedSpecialCampaigns.length > 0
        ? this.findMatchingSpecialCampaigns(
            selectedSpecialCampaigns,
            specialCampaignOptions
          )
        : selectedSpecialCampaigns;

    const newSelectedAccounts =
      selectedAccount !== ''
        ? this.findMatchingSelectedAccounts(selectedAccount, accountOptions)
        : selectedAccount;

    this.setState({
      oem: newSelectedOem,
      market: markets,
      accountOptions,
      oemsOptions,
      specialCampaignOptions,
      selectedMarkets,
      selectedAccount: newSelectedAccounts,
      selectedSpecialCampaigns: newSelectedSpecialCampaigns
    });
  };

  // to do: make a more general function for finding matches with the changed options and current state
  findMatchingSelectedAccounts = (currentSelectedAccounts, accountsOptions) => {
    const currentSelectedAccountsArray = currentSelectedAccounts.split(',');
    const matchedAccounts = [];

    for (let i = 0; i < accountsOptions.length; i += 1) {
      for (let j = 0; j < currentSelectedAccountsArray.length; j += 1) {
        if (accountsOptions[i].value === currentSelectedAccountsArray[j]) {
          matchedAccounts.push(currentSelectedAccountsArray[j]);
        }
      }
    }
    const newSelectedAccounts = matchedAccounts.join();

    return newSelectedAccounts;
  };

  findMatchingSelectedMarkets = (currentSelectedMarkets, marketOptions) => {
    const matchedMarkets = [];
    let newMarkets = '';

    for (let i = 0; i < marketOptions.length; i += 1) {
      for (let j = 0; j < currentSelectedMarkets.length; j += 1) {
        if (marketOptions[i].value === currentSelectedMarkets[j]) {
          matchedMarkets.push(currentSelectedMarkets[j]);
        }
      }
    }

    matchedMarkets.map((market) => {
      if (market === undefined) {
        newMarkets += '';
      } else {
        newMarkets += newMarkets === '' ? market : `,${market}`;
      }
    });

    return { market: newMarkets, selectedMarkets: matchedMarkets };
  };

  findMatchingOem = (currentOem, oemOptions) => {
    let matchedOem = '';

    for (let i = 0; i < oemOptions.length; i += 1) {
      if (oemOptions[i].value === currentOem) {
        matchedOem = currentOem;
      }
    }

    return matchedOem;
  };

  findMatchingSpecialCampaigns = (
    currentSpecialCampaign,
    specialCampaignOptions
  ) => {
    const matchedSpecialCampaigns = [];

    for (let i = 0; i < specialCampaignOptions.length; i += 1) {
      for (let j = 0; j < currentSpecialCampaign.length; j += 1) {
        if (specialCampaignOptions[i].value === currentSpecialCampaign[j]) {
          matchedSpecialCampaigns.push(currentSpecialCampaign[j]);
        }
      }
    }

    return matchedSpecialCampaigns;
  };

  onSpecialCampaignSelect = (event, { value, options }) => {
    let specialCampaigns = '';
    const selectedSpecialCampaigns = [];

    value.map((val) => {
      const specialCampaign = _.find(options, (option) => {
        return option.value === val;
      });
      if (specialCampaign === undefined || specialCampaign.text === undefined) {
        specialCampaigns += '';
      } else {
        specialCampaigns +=
          specialCampaigns === ''
            ? specialCampaign.text
            : `,${specialCampaign.text}`;
        selectedSpecialCampaigns.push(specialCampaign.value);
      }
    });

    this.setState({
      selectedSpecialCampaigns
    });
  };

  // traverse array of chosen funding tags and see which current dashboard options
  // have countain the currently selected tags (matching by tag id)
  matchFundingTags = (fundingTagIds, dashboardOptions) => {
    const newMatchedDashboards =
      fundingTagIds.length <= 0 ? dashboardOptions : [];
    if (newMatchedDashboards.length <= 0) {
      for (let i = 0; i < dashboardOptions.length; i += 1) {
        const dashboardOptionHasFundingTierTags = this.returnIfDashboardHasNoFundingTierTags(
          dashboardOptions[i]
        );
        if (!dashboardOptionHasFundingTierTags) {
          newMatchedDashboards.push(dashboardOptions[i]);
        } else {
          for (let j = 0; j < fundingTagIds.length; j += 1) {
            const tagsToMatch = dashboardOptions[i].tags;
            const found = tagsToMatch.find(
              (tag) => tag.tag_id === fundingTagIds[j]
            );
            if (found) {
              newMatchedDashboards.push(dashboardOptions[i]);
            }
          }
        }
      }
    }
    return newMatchedDashboards;
  };

  // check if dashboard has no funding/tier tags selected
  // traverse the tags of a dashboard to see if any of its
  // tags are from the 'funding' category
  returnIfDashboardHasNoFundingTierTags = (dashboardOption) => {
    const { tagsByCategoryOptions } = this.state;
    let dashboardHasFundingTierTags = false;
    const { tags } =
      tagsByCategoryOptions.find(
        (tagGroup) => tagGroup.category === 'funding'
      ) || {};
    if (tags) {
      const { tags: dashboardTags } = dashboardOption;
      if (dashboardTags) {
        tags.forEach((tag) => {
          const { value: tagId } = tag;
          dashboardTags.forEach((dashboardTag) => {
            const { tag_id: dashboardTagId } = dashboardTag;
            if (dashboardTagId === tagId) {
              dashboardHasFundingTierTags = true;
            }
          });
        });
      }
    }
    return dashboardHasFundingTierTags;
  };

  onFundingTagSelect = (event, data) => {
    let fundings = '';
    const chosenFundingTags = [];
    data.value.map((val) => {
      const funding = _.find(data.options, (option) => {
        return option.value === val;
      });
      if (funding === undefined || funding.text === undefined) {
        fundings += '';
      } else {
        fundings += fundings === '' ? funding.text : `,${funding.text}`;
        chosenFundingTags.push(funding.value);
      }
    });

    const { dashboardOptions, chosenTagsByCategory } = this.state;

    const newMatchedDashboards = this.matchFundingTags(
      chosenFundingTags,
      dashboardOptions
    );
    let filteredNewMatchedDashboards = [];

    if (chosenTagsByCategory.length > 0) {
      const currentTagsInState = chosenTagsByCategory;
      const newStateArray = [...currentTagsInState];

      filteredNewMatchedDashboards =
        chosenFundingTags.length > 0
          ? newMatchedDashboards.filter((dashboard) =>
              this.dashboardHasTags(dashboard, newStateArray)
            )
          : dashboardOptions.filter((dashboard) =>
              this.dashboardHasTags(dashboard, newStateArray)
            );
    } else {
      filteredNewMatchedDashboards = newMatchedDashboards;
    }

    this.setState({
      funding: fundings,
      chosenFundingTags,
      matchedDashboards: filteredNewMatchedDashboards
    });
  };

  onAccountSelect = async (event, data) => {
    let accounts = '';
    const {
      selectedAccount,
      commaListVisible,
      selectedSpecialCampaigns,
      filters
    } = this.state;
    const stateToChange = selectedAccount;

    if (stateToChange === '' && commaListVisible) {
      document.getElementsByName('commaSeparatedInput')[0].value = '';
    }

    data.value.map((val) => {
      const account = _.find(data.options, (option) => {
        return option.value === val;
      });
      if (account === undefined || account.text === undefined) {
        accounts += '';
      } else {
        accounts += accounts === '' ? account.text : `,${account.text}`;
      }
    });

    if (accounts) {
      const filterOptions = filters.filter(
        (filter) => accounts.split(',').indexOf(filter.account || filter) !== -1
      );

      const specialCampaignOptions = [];

      filterOptions.forEach((op, index) => {
        op.special_campaigns.forEach((specialCampaign) => {
          if (
            !specialCampaignOptions.find(
              (scOp) => scOp && scOp.text === specialCampaign
            )
          ) {
            if (specialCampaign !== null && specialCampaign.trim() !== '') {
              specialCampaignOptions.push({
                key: index + 1,
                value: specialCampaign,
                text: specialCampaign
              });
            }
          }
        });
      });

      const managedServicesOption = {
        key: specialCampaignOptions.length + 2,
        value: 'Managed Services',
        text: 'Managed Services'
      };

      specialCampaignOptions.push(managedServicesOption);

      if (selectedSpecialCampaigns.length > 0) {
        const newSelectedSpecialCampaigns = this.findMatchingSpecialCampaigns(
          selectedSpecialCampaigns,
          specialCampaignOptions
        );

        this.setState({
          selectedAccount: accounts,
          selectedSpecialCampaigns: newSelectedSpecialCampaigns,
          specialCampaignOptions
        });
      } else {
        this.setState({ selectedAccount: accounts, specialCampaignOptions });
      }
    }

    this.setState({ selectedAccount: accounts });
  };

  trimSplitElements = (inputArray) => {
    const trimmedArray = [];
    for (let i = 0; i < inputArray.length; i += 1) {
      trimmedArray.push(inputArray[i].trim());
    }
    return trimmedArray;
  };

  verifyAccountValues = (adAccountOptions, adAccountsArray) => {
    const verifiedAccounts = [];
    for (let i = 0; i < adAccountOptions.length; i += 1) {
      for (let j = 0; j < adAccountsArray.length; j += 1) {
        if (adAccountsArray[j] === adAccountOptions[i].value) {
          verifiedAccounts.push(adAccountsArray[j]);
        }
      }
    }
    return verifiedAccounts;
  };

  onCommaInputChange = async (event) => {
    let accounts = '';
    const currentAccountOptions = this.state.accountOptions;
    const target = event.target;
    const value = target.value;
    const name = target.name;
    const adAccountsFromValue = value.split(',');
    const trimmedArray = this.trimSplitElements(adAccountsFromValue);

    const verifiedAdAccounts = this.verifyAccountValues(
      currentAccountOptions,
      trimmedArray
    );

    verifiedAdAccounts.map((account) => {
      accounts += accounts === '' ? account : `,${account}`;
    });

    this.setState({ [name]: accounts });
  };

  onDashboardSelect = async (event, { value, options }) => {
    let dashboards = '';
    const newStateArray = [];

    try {
      value.map((val) => {
        const dashboard = _.find(options, (option) => {
          return option.value === val;
        });

        dashboards +=
          dashboards === '' ? dashboard.value : `,${dashboard.value}`;
        newStateArray.push(dashboard.value);
      });
    } catch (error) {
      toast.warn(
        'It looks like the dashboards could not be retrieved from server!',
        {
          position: 'bottom-center',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true
        }
      );

      console.log('Error in onDashboardSelect()', error);
    }
    const dashboardForPreview =
      value && value.length > 0 ? value[value.length - 1] : '';

    this.setState({
      selectedDashboards: dashboards,
      selectedDashboardsArray: newStateArray,
      selectedDashboardForPreview: dashboardForPreview
    });
  };

  onDashboardSelectForPreview = (event, data) => {
    const dashboard = _.find(data.options, (option) => {
      return option.value === data.value;
    });

    this.setState({ selectedDashboardForPreview: dashboard.value });
  };

  onDateSelect = (event, data) => {
    this.setState({ selectedDate: data.value, dateFrom: '', dateTo: '' });
  };

  onTagOptionSelect = (event, { name, value }) => {
    const {
      chosenFundingTags,
      matchedDashboards,
      dashboardOptions,
      chosenTagsByCategory
    } = this.state;
    let preFilteredDashbboards = [];
    const currentTagsInState = chosenTagsByCategory;
    const newStateArray = [...currentTagsInState];

    const chosenTagByCategory = {
      category: name,
      tag: value
    };

    const foundTagIndex = newStateArray.findIndex((tag) => {
      return tag.category === chosenTagByCategory.category;
    });

    if (foundTagIndex === -1) {
      newStateArray.push(chosenTagByCategory);
      preFilteredDashbboards =
        chosenFundingTags.length > 0
          ? matchedDashboards.filter((dashboard) =>
              this.dashboardHasTags(dashboard, newStateArray)
            )
          : dashboardOptions.filter((dashboard) =>
              this.dashboardHasTags(dashboard, newStateArray)
            );
    } else {
      newStateArray.splice(foundTagIndex, 1);
      newStateArray.push(chosenTagByCategory);

      if (chosenFundingTags.length > 0) {
        const fundingFilteredDashboards = this.matchFundingTags(
          chosenFundingTags,
          dashboardOptions
        );
        preFilteredDashbboards = fundingFilteredDashboards.filter((dashboard) =>
          this.dashboardHasTags(dashboard, newStateArray)
        );
      } else {
        preFilteredDashbboards = dashboardOptions.filter((dashboard) =>
          this.dashboardHasTags(dashboard, newStateArray)
        );
      }
    }
    const newMatchedDashboards = preFilteredDashbboards;

    this.setState({
      ...this.state,
      chosenTagsByCategory: newStateArray,
      selectedDashboardsArray: [],
      matchedDashboards: newMatchedDashboards
    });
  };

  dashboardHasTags = (dashboard, selectedTags) => {
    let hasTags = true;
    selectedTags.forEach((tag) => {
      if (tag.category !== 'special_campaign') {
        const existTag = dashboard.tags.find((item) => item.tag_id === tag.tag);
        if (tag.tag && !existTag) {
          hasTags = false;
        }
      }
    });

    return hasTags;
  };

  selectRangeDate = (day, range) => {
    let dateFrom = this.state.dateFrom;
    let dateTo = this.state.dateTo;

    if (range === 'from') {
      dateFrom = day;
    } else {
      dateTo = day;
    }
    this.setState({ dateFrom, dateTo, selectedDate: '' });
  };

  validInput = () => {
    const {
      selectedDashboards,
      selectedAccount,
      commaSeparatedInput,
      selectedDate,
      dateFrom,
      dateTo,
      oem,
      restrictByOem
    } = this.state;

    let validInput = false;

    if (restrictByOem) {
      validInput =
        oem && selectedDashboards && (selectedDate || (dateFrom && dateTo));
    } else {
      validInput =
        selectedDashboards &&
        (selectedAccount || commaSeparatedInput) &&
        (selectedDate || (dateFrom && dateTo));
    }

    if (!validInput) {
      const errorMessage = restrictByOem
        ? 'You must select an OEM, dashboard and date'
        : 'You must select an account, dashboard and date';
      toast.error(errorMessage, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
      });
    }

    return validInput;
  };

  validInputForPreview = () => {
    const {
      selectedDashboards,
      selectedAccount,
      commaSeparatedInput,
      selectedDate,
      dateFrom,
      dateTo,
      oem,
      restrictByOem
    } = this.state;

    let validInputForPreview = false;

    if (restrictByOem) {
      validInputForPreview =
        oem && selectedDashboards && (selectedDate || (dateFrom && dateTo));
    } else {
      validInputForPreview =
        selectedDashboards &&
        (selectedAccount || commaSeparatedInput) &&
        (selectedDate || (dateFrom && dateTo));
    }

    if (!validInputForPreview) {
      const errorMessage = restrictByOem
        ? 'You must select an OEM, dashboard and date'
        : 'You must select an account, dashboard and date';
      toast.error(errorMessage, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
      });
    }
    return validInputForPreview;
  };

  formatDatePart = (datePart) => {
    return datePart < 10 ? `0${datePart}` : datePart;
  };

  getDate = () => {
    let date = this.state.selectedDate;
    const { dateFrom, dateTo, selectedDate } = this.state;

    if (dateFrom && dateTo) {
      const from = new Date(dateFrom);
      const to = new Date(dateTo);
      date = `${from.getFullYear()}/${this.formatDatePart(
        from.getMonth() + 1
      )}/${this.formatDatePart(
        from.getDate()
      )}  to ${to.getFullYear()}/${this.formatDatePart(
        to.getMonth() + 1
      )}/${this.formatDatePart(to.getDate())} `;
    } else if (selectedDate === 'Last Week') {
      const lastWeek = getLastWeek();
      date = `${lastWeek.startDate.getFullYear()}/${this.formatDatePart(
        lastWeek.startDate.getMonth() + 1
      )}/${this.formatDatePart(
        lastWeek.startDate.getDate()
      )}  to ${lastWeek.endDate.getFullYear()}/${this.formatDatePart(
        lastWeek.endDate.getMonth() + 1
      )}/${this.formatDatePart(lastWeek.endDate.getDate())} `;
    } else if (selectedDate === 'Last Month') {
      const lastMonth = getLastMonth();
      date = `${lastMonth.startDate.getFullYear()}/${this.formatDatePart(
        lastMonth.startDate.getMonth() + 1
      )}/${this.formatDatePart(
        lastMonth.startDate.getDate()
      )}  to ${lastMonth.endDate.getFullYear()}/${this.formatDatePart(
        lastMonth.endDate.getMonth() + 1
      )}/${this.formatDatePart(lastMonth.endDate.getDate())} `;
    }

    return date;
  };

  shareIframe = async () => {
    if (!this.validInput()) {
      return false;
    }

    this.setState({ showForm: true });
    const uniqueId = `${shortid.generate()}${shortid.generate()}${shortid.generate()}`;
    let urlString = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
    urlString = urlString.replace('insightsPreview', 'insightsPreview/detail');

    const date = this.getDate();

    const {
      selectedWeeks,
      selectedAccount,
      commaSeparatedInput,
      selectedDashboards,
      selectedMarkets,
      selectedSpecialCampaigns,
      oem,
      chosenFundingTags,
      funding,
      hasPassword
    } = this.state;

    const expirationDate = new Date();
    const days = selectedWeeks;
    expirationDate.setDate(expirationDate.getDate() + days);

    const iframeData = {
      account: selectedAccount || commaSeparatedInput,
      date,
      url: uniqueId,
      user: this.props.user.email,
      active: '1',
      expired_at: expirationDate.toISOString().split('T')[0],
      dashboards: selectedDashboards,
      oem: oem || null,
      market:
        selectedMarkets && selectedMarkets.length > 0
          ? selectedMarkets.join(',')
          : null,
      campaign:
        selectedSpecialCampaigns && selectedSpecialCampaigns.length > 0
          ? selectedSpecialCampaigns.join(',')
          : null,
      funding:
        chosenFundingTags && chosenFundingTags.length > 0 ? funding : null,
      hasPassword
    };

    const result = await insertIframe(iframeData);
    const { data: insertIframeData } = result;
    const { url, password = '' } = insertIframeData;
    try {
      await this.getIframes();
      urlString = `${urlString}/${url}`;
      const stateParams = { ...this.state, urlString };
      if (password) {
        stateParams.currentPassword = password;
      }
      this.setState(stateParams);
      return true;
    } catch (error) {
      toast.warn('Something went wrong with generating the share link!', {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
      });
      console.log('Error with InsertIframes(): ', error);
      return false;
    }
  };

  viewMetrics = async () => {
    if (!this.validInputForPreview()) {
      return false;
    }

    const date = this.getDate();
    const {
      selectedAccount,
      commaSeparatedInput,
      selectedDashboardForPreview,
      oem,
      selectedMarkets,
      selectedSpecialCampaigns,
      chosenFundingTags,
      funding
    } = this.state;

    const email = this.props.user.email;
    const parameters = {
      accountName: selectedAccount || commaSeparatedInput,
      date,
      uniqueId: email,
      dashboardId: selectedDashboardForPreview,
      oem: oem || null,
      market:
        selectedMarkets && selectedMarkets.length > 0
          ? selectedMarkets.join(',')
          : null,
      campaign:
        selectedSpecialCampaigns && selectedSpecialCampaigns.length > 0
          ? selectedSpecialCampaigns.join(',')
          : null,
      funding:
        chosenFundingTags && chosenFundingTags.length > 0 ? funding : null
    };

    const result = await generateIframeForAccount(parameters);
    const iframe = result.statusCode === 200 ? result.iframe : '';
    this.setState({ iframe });
    return true;
  };

  onCloseForm = () => {
    this.setState({
      ...this.state,
      showForm: false,
      copied: false,
      currentPassword: ''
    });
  };

  renderLoadingOrCopy = (urlString) => {
    if (urlString.length === 0) {
      return <Loader inline className="active" />;
    }

    const { shareLinkOpen, shareLinkPopupText, currentPassword } = this.state;

    return (
      <div>
        <span style={{ outline: 'none' }}>
          <Popup
            trigger={
              <a href={urlString} target="_new">
                {urlString}
              </a>
            }
            on="hover"
            content={shareLinkPopupText}
            open={shareLinkOpen}
            onClose={this.handleShareLinkClose}
            onOpen={this.handleShareLinkHover}
            position="top left"
          />
          {currentPassword && (
            <div>
              <Divider hidden />

              <span>Iframe password:</span>
              <Popup
                content="Click to copy this password. You will need it to view the Iframe. You can reset the password by doing the following: 1. Toggle the lock. 2. Generate The Preview 3. Toggle the lock again generate the preview again."
                trigger={
                  <CopyToClipboard
                    style={{ cursor: 'pointer' }}
                    text={currentPassword}
                    onCopy={() => {
                      this.onCopy('The password has been copied.');
                    }}
                  >
                    <p>{currentPassword}</p>
                  </CopyToClipboard>
                }
              />
            </div>
          )}
        </span>
        <CopyToClipboard
          style={{ cursor: 'pointer' }}
          text={urlString}
          onCopy={() => {
            this.onCopy('The share link has been copied.');
          }}
        >
          <Form.Button size="small" floated="right">
            Copy URL
          </Form.Button>
        </CopyToClipboard>
        <Divider hidden />
      </div>
    );
  };

  onCopy = (message) => {
    this.setState({ copied: true });
    toast.info(message, {
      position: 'bottom-center',
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true
    });
  };

  onWeekSelect = (event, data) => {
    this.setState({ selectedWeeks: data.value });
  };

  fillWeeks = () => {
    const weeks = [
      { key: 1, text: '1 week', value: 7 },
      { key: 2, text: '2 weeks', value: 14 },
      { key: 3, text: '3 weeks', value: 21 },
      { key: 4, text: '4 weeks', value: 28 },
      { key: 5, text: '3 months', value: 90 },
      { key: 6, text: '6 months', value: 180 },
      { key: 7, text: 'Year', value: 365 }
    ];

    this.setState({ weeksOptions: weeks });
  };

  removeIframe = async (id) => {
    await removeIframe(id);
    await this.getIframes();
  };

  updateIframe = async (iframe) => {
    const updateIframeResult = await updateIframe(iframe);
    const { statusCode } = updateIframeResult;
    if (statusCode === 200) {
      await this.getIframes();
    }
    return statusCode;
  };

  refreshAccounts = async () => {
    // this returns an array of strings
    const nonSocialAccounts = await refreshLookerAccounts();

    try {
      const accountOptions = _.sortBy(
        _.map(nonSocialAccounts, (op, index) => ({
          key: index,
          value: op,
          text: op
        })),
        'text'
      );

      this.setState({
        accountOptions
      });
    } catch (error) {
      console.log(error);
    }
  };

  getTagName = (category) => {
    switch (category) {
      case 'dashboard_type':
        return 'Type';
      case 'funding':
        return 'Tier';
      case 'special_campaign':
        return 'Campaign';
      default:
        return category;
    }
  };

  showCommaListInput = () => {
    const { commaListVisible } = this.state;
    if (!commaListVisible) {
      this.setState({ commaListVisible: true });
    } else {
      this.setState({ commaListVisible: false });
    }
  };

  showDatePickerInput = () => {
    const { datePickerVisible } = this.state;
    if (!datePickerVisible) {
      this.setState({ datePickerVisible: true });
    } else {
      this.setState({ datePickerVisible: false });
    }
  };

  handleShareLinkHover = () => {
    this.setState({
      shareLinkOpen: true,
      shareLinkPopupText:
        'By clicking the link, you will open the share link in a new tab'
    });
    this.timeout = setTimeout(() => {
      this.setState({ shareLinkOpen: false });
    }, 2500);
  };

  handleShareLinkClick = () => {};

  handleShareLinkClose = () => {
    this.setState({ shareLinkOpen: false });
    clearTimeout(this.timeout);
  };
  handleRestrictByOemToggle = () => {
    this.setState({ restrictByOem: !this.state.restrictByOem });
  };

  render() {
    const {
      showForm,
      urlString,
      selectedAccount,
      commaSeparatedInput,
      accountOptions,
      dashboardOptions,
      matchedDashboards,
      selectedDate,
      datesOptions,
      dateFrom,
      dateTo,
      selectedDashboardForPreview,
      weeksOptions,
      iframe,
      iframes,
      tagsByCategoryOptions,
      chosenTagsByCategory,
      chosenFundingTags,
      oemsOptions,
      marketOptions,
      specialCampaignOptions,
      selectedMarkets,
      selectedSpecialCampaigns,
      oem,
      commaListVisible,
      datePickerVisible,
      selectedDashboardsArray,
      restrictByOem,
      hasPassword
    } = this.state;

    return (
      <div className="insights-container">
        <Modal dimmer="inverted" open={showForm} onClose={this.onCloseForm}>
          <Modal.Header>Share Iframe</Modal.Header>
          <Modal.Content>
            Share Looker Iframe
            {this.renderLoadingOrCopy(urlString)}
          </Modal.Content>
          <div />
        </Modal>
        <Tab
          panes={[
            {
              key: 'prepare-link',
              menuItem: 'Prepare Link',
              render: () => (
                <Tab.Pane>
                  <ToastContainer
                    position="bottom-center"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnVisibilityChange
                    draggable
                    pauseOnHover
                  />
                  <Divider hidden />
                  <h3>Choose your Dashboard tags</h3>
                  <Divider hidden />
                  <Button
                    className="insights-reset-button"
                    color="orange"
                    onClick={this.resetDashboardsTags}
                  >
                    Reset Tags
                  </Button>
                  <Divider hidden />
                  <h4>OEM</h4>
                  <Grid>
                    <Grid.Row columns={6} verticalAlign="middle">
                      <Grid.Column width={3}>
                        <Dropdown
                          id="oem"
                          placeholder="OEM"
                          search
                          options={oemsOptions}
                          selection
                          className="tag-dropdown"
                          name="oem"
                          value={oem}
                          onChange={this.onOemSelect}
                        />
                      </Grid.Column>
                      <Grid.Column width={3}>
                        <Popup
                          trigger={
                            <Checkbox
                              label="Restrict Data by OEM"
                              checked={restrictByOem}
                              onChange={this.handleRestrictByOemToggle}
                            />
                          }
                          on="hover"
                          content="Enabling means you can preview and share dashboards without selecting accounts, but you need to select an OEM."
                          position="top left"
                        />
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                  <Divider hidden />
                  <h4>Tier</h4>
                  {tagsByCategoryOptions
                    .filter((item) => item.category === 'funding')
                    .map((tagGroup, index) => {
                      return (
                        <Dropdown
                          key={`funding-tier-dropdown-${index}`}
                          id="funding"
                          placeholder="Tier"
                          search
                          multiple
                          options={tagGroup.tags}
                          selection
                          className="tag-dropdown"
                          name="funding"
                          value={chosenFundingTags}
                          onChange={this.onFundingTagSelect}
                        />
                      );
                    })}
                  <Divider hidden />
                  <h4>Market</h4>
                  <Dropdown
                    id="market"
                    placeholder="Market"
                    search
                    multiple
                    options={marketOptions}
                    selection
                    className="tag-dropdown"
                    name="market"
                    value={selectedMarkets}
                    onChange={this.onMarketSelect}
                  />
                  <Divider hidden />
                  {tagsByCategoryOptions
                    .filter((item) => item.category === 'dashboard_type')
                    .map((tagGroup, index) => {
                      const { category: tagGroupCategory } = tagGroup;
                      const chosenTag = chosenTagsByCategory.find((tag) => {
                        const { category } = tag;

                        return category === tagGroupCategory;
                      });

                      const { tag: value } = chosenTag || {};

                      return (
                        <div key={`${value}-dropdown-div-${index}`}>
                          <h4>{this.getTagName(tagGroup.category)}</h4>
                          <Dropdown
                            id={tagGroup.category}
                            placeholder={this.getTagName(tagGroup.category)}
                            search
                            options={tagGroup.tags}
                            selection
                            className="tag-dropdown"
                            name={tagGroup.category}
                            value={value}
                            onChange={this.onTagOptionSelect}
                          />
                          <Divider hidden />
                        </div>
                      );
                    })}

                  <div>
                    <h4>
                      Account
                      <Icon
                        name="refresh"
                        onClick={() => this.refreshAccounts()}
                        style={{ paddingLeft: '1%' }}
                      />
                    </h4>
                    <p>
                      You may either paste in a comma separated list or use the
                      dropdown menu.
                    </p>
                  </div>

                  <Divider hidden />

                  <Grid largescreen={10} widescreen={7}>
                    <Grid.Row>
                      <Grid.Column largescreen={3} widescreen={2}>
                        <Dropdown
                          placeholder="Ad Accounts"
                          className="insights-accounts"
                          disabled={commaSeparatedInput !== ''}
                          search
                          multiple
                          value={
                            selectedAccount ? selectedAccount.split(',') : []
                          }
                          selection
                          options={accountOptions || []}
                          onChange={this.onAccountSelect}
                        />
                      </Grid.Column>

                      <Grid.Column largescreen={2} widescreen={1}>
                        <Button
                          icon
                          labelPosition={commaListVisible ? 'left' : 'right'}
                          onClick={this.showCommaListInput}
                        >
                          {commaListVisible ? 'Pick' : 'Paste'}
                          {commaListVisible ? (
                            <Icon name="left arrow" />
                          ) : (
                            <Icon name="right arrow" />
                          )}
                        </Button>
                      </Grid.Column>
                      {commaListVisible ? (
                        <Grid.Column largescreen={5} widescreen={4}>
                          <TextArea
                            name="commaSeparatedInput"
                            cols={100}
                            className={
                              selectedAccount !== ''
                                ? 'insights-accounts-textarea-disabled'
                                : 'insights-accounts-textarea'
                            }
                            onChange={this.onCommaInputChange}
                            placeholder="Paste in comma-separated list of ad account names here"
                            disabled={selectedAccount !== ''}
                          />
                        </Grid.Column>
                      ) : null}
                    </Grid.Row>
                  </Grid>

                  <Divider hidden />
                  <h4>Campaigns</h4>
                  <Dropdown
                    id="special_campaign"
                    placeholder="Campaigns"
                    search
                    multiple
                    options={specialCampaignOptions}
                    selection
                    className="tag-dropdown"
                    name="special_campaign"
                    value={selectedSpecialCampaigns}
                    onChange={this.onSpecialCampaignSelect}
                  />
                  <Divider hidden />

                  <h3>Choose your Timeframe</h3>
                  <Grid>
                    <Grid.Row>
                      <Grid.Column largescreen={3} widescreen={2}>
                        <Dropdown
                          placeholder="Dates"
                          search
                          selection
                          value={selectedDate}
                          options={datesOptions}
                          onChange={this.onDateSelect}
                        />
                      </Grid.Column>
                      <Grid.Column largescreen={2} widescreen={1}>
                        <Button
                          icon
                          labelPosition={datePickerVisible ? 'left' : 'right'}
                          // to do: make general ui toggle function
                          onClick={this.showDatePickerInput}
                        >
                          {datePickerVisible ? 'Menu' : 'Dates'}
                          {datePickerVisible ? (
                            <Icon name="left arrow" />
                          ) : (
                            <Icon name="right arrow" />
                          )}
                        </Button>
                      </Grid.Column>
                      {datePickerVisible ? (
                        <Grid.Column largescreen={6} widescreen={5}>
                          <Icon
                            className="insights-calendar-icon"
                            name="calendar"
                            size="big"
                          />
                          <div className="insights-date-input">
                            <DayPickerInput
                              placeholder="From"
                              onDayChange={(day) =>
                                this.selectRangeDate(day, 'from')
                              }
                              value={dateFrom}
                            />
                          </div>
                          <Icon
                            className="insights-calendar-icon"
                            name="calendar"
                            size="big"
                          />
                          <DayPickerInput
                            placeholder="To"
                            onDayChange={(day) =>
                              this.selectRangeDate(day, 'to')
                            }
                            value={dateTo}
                          />
                        </Grid.Column>
                      ) : null}
                    </Grid.Row>
                  </Grid>
                  <Divider hidden />
                  <Divider hidden />
                  <h3>Choose your Dashboard</h3>
                  <Divider hidden />
                  <Dropdown
                    placeholder="Dashboards"
                    className="insights-accounts"
                    search
                    multiple
                    selection
                    value={selectedDashboardsArray}
                    options={matchedDashboards}
                    onChange={this.onDashboardSelect}
                  />
                  <Divider hidden />
                  <Divider hidden />
                  <h3>Preview Dashboard</h3>
                  <Divider hidden />
                  <Dropdown
                    placeholder="Dashboards"
                    className="insights-accounts"
                    search
                    selection
                    value={selectedDashboardForPreview}
                    options={matchedDashboards}
                    onChange={this.onDashboardSelectForPreview}
                  />
                  <Button
                    color="blue"
                    disabled={!selectedDashboardForPreview}
                    className="preview-metrics-button"
                    onClick={() => this.viewMetrics()}
                  >
                    Preview Metrics
                  </Button>
                  <div className="insights-expiration-container">
                    <div className="insights-expiration-title">
                      Select Exp. Time:{' '}
                    </div>
                    <div>
                      <Dropdown
                        placeholder="Expiration"
                        selection
                        defaultValue={365}
                        options={weeksOptions || []}
                        onChange={this.onWeekSelect}
                      />
                    </div>
                    <Button
                      color="blue"
                      className="insights-share-button"
                      onClick={() => this.shareIframe()}
                      content="Share This Iframe"
                    />
                    <Popup
                      basic
                      position="top left"
                      content={
                        hasPassword
                          ? 'The Iframe can only be viewed if the user has the correct password.'
                          : 'The Iframe is viewable to all.'
                      }
                      trigger={
                        <Button
                          color={hasPassword ? 'green' : 'grey'}
                          icon={hasPassword ? 'lock' : 'lock open'}
                          onClick={() => {
                            this.setState({
                              ...this.state,
                              hasPassword: !hasPassword
                            });
                          }}
                        />
                      }
                    />
                  </div>
                  <Divider hidden />
                  {iframe ? (
                    <iframe
                      title="Insights Preview Metrics Iframe"
                      className="insights-iframe"
                      src={iframe}
                    />
                  ) : null}
                </Tab.Pane>
              )
            },
            {
              key: 'existing-link',
              menuItem: 'Existing Links',
              render: () => (
                <Tab.Pane>
                  <InsightsList
                    iframes={iframes}
                    removeIframe={this.removeIframe}
                    updateIframe={this.updateIframe}
                    dashboards={dashboardOptions}
                  />
                </Tab.Pane>
              )
            }
          ]}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(InsightsPreview);



// WEBPACK FOOTER //
// ./src/screens/InsightsPreview/InsightsPreview.js